module.exports = __webpack_public_path__ + "83bca600ed422f9f3e0c2896ad276646.pdf";